// services/productsApi.ts
import apiClient from "./apiClient";

export interface Product {
  id: number;
  name: string;
  sku: string;
  hsnCode: string;
  price: number;
  packQuantity: number;
  unitId: number;
  gstPercent: string;
  organizationId: number;
  createdBy: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  Unit?: {
    id: number;
    name: string;
    symbol: string;
  };
  creator?: {
    id: number;
    ownerName: string;
  };
}

export interface ProductsResponse {
  products: Product[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export const productsApi = {
  getAll: async (
    page: number,
    limit: number,
    search: string,
  ): Promise<ProductsResponse> => {
    const response = await apiClient.get("/products", {
      params: { page, limit, search: search.trim() || undefined },
    });
    return response.data;
  },
  getById: async (id: number): Promise<{ product: Product }> => {
    const response = await apiClient.get(`/products/${id}`);
    return response.data;
  },
  create: async (data: {
    name: string;
    sku: string;
    hsnCode: string;
    price: number;
    packQuantity: number;
    unitId: number;
    gstPercent: string;
  }): Promise<{ message: string; product: Product }> => {
    const response = await apiClient.post("/products", data);
    return response.data;
  },
  update: async (
    id: number,
    data: Partial<
      Omit<
        Product,
        "id" | "organizationId" | "createdBy" | "createdAt" | "updatedAt"
      >
    >,
  ): Promise<{ message: string; product: Product }> => {
    const response = await apiClient.put(`/products/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/products/${id}`);
    return response.data;
  },
};
